module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch5",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "aria-label": "7",
      "id": "pg_7",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Does He Hit You?")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "VSB"
  }, [_vm._v("Blows without hands.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Each strike a verbal assault.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Intimidation with a stare.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eca1116c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 84
// module chunks = 0